// Dependencies
require("section/confirmation");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/confirmation/index.js
 ** module id = 186
 ** module chunks = 0 1
 **/